import { Dialog, Transition } from "@headlessui/react";
import React, { Fragment } from "react";
import Close from "../../VibehutUI/Icons/Close";
import ResourceInfoCard from "../ResourceInfoCard";
import { getUserData } from "../../services/userService";

function ResourceModal({
  isOpen,
  setIsOpen,
  tag,
  roomResourceState,
  roomId,
  roomOwner,
}) {
  return (
    <>
      <Transition appear show={isOpen} as={Fragment}>
        <Dialog
          as="div"
          className="fixed inset-0 z-40 overflow-y-auto"
          onClose={() => setIsOpen(false)}
        >
          <div className="min-h-screen px-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Dialog.Overlay className="fixed inset-0 bg-overlay bg-opacity-75 transition-opacity" />
            </Transition.Child>
            <span
              className="inline-block h-screen align-middle"
              aria-hidden="true"
            >
              &#8203;
            </span>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <div className="inline-block w-full max-w-md  text-left overflow-hidden align-middle transition-all transform bg-white shadow-xl rounded-2xl">
                <div className="bg-white dark:bg-navyGray p-4 border-b border-frescoWhite dark:border-matteGray">
                  <div className="flex justify-between items-center">
                    <p className="font-medium text-lg text-darkNight dark:text-frescoWhite">
                      Resources {tag && `for ${tag}`}
                    </p>
                    <span
                      className="bg-frescoWhite p-9px rounded-full cursor-pointer"
                      onClick={() => setIsOpen(false)}
                      tabindex="0"
                    >
                      <Close />
                    </span>
                  </div>
                </div>
                <div className="bg-white dark:bg-navyGray px-3 h-96 py-3 ">
                  <div className="searchbarDiv overflow-y-scroll  custom-scrollbar h-full relative grow">
                    {roomResourceState &&
                      roomResourceState.map((resource, index) => {
                        return (
                          <div key={resource._id + index} className="">
                            <ResourceInfoCard
                              companyName={resource.companyName}
                              tags={resource.tags}
                              label={resource.label}
                              location={resource.location[0]}
                              testimonial={resource.testimonial}
                              url={resource.url}
                              count={resource.count}
                              id={resource._id}
                              description={resource.description}
                              votes={resource.votes || []}
                              createdAt={resource.createdAt || new Date()}
                              username={
                                resource.owner && resource.owner.length > 0
                                  ? getUserData(resource.owner[0]).username
                                  : ""
                              }
                              chatCount={
                                resource?.specificChatRoom[0]?.chatCount
                                  ? resource.specificChatRoom[0].chatCount
                                  : 0
                              }
                              roomOwner={roomOwner}
                              roomId={roomId}
                              resourceOwner={
                                resource.owner && resource.owner.length > 0
                                  ? getUserData(resource.owner[0])
                                  : ""
                              }
                            />
                          </div>
                        );
                      })}
                  </div>
                </div>
              </div>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition>
    </>
  );
}
export default ResourceModal;
